module.exports = __webpack_public_path__ + "img/france-ligue-1-11__dark.7fecb585.png";